/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_IntroInputs */

const en_gc_home_intro = /** @type {(inputs: Gc_Home_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An open-source spreadsheet, a familiar way of thinking. GridCraft brings cells, formulas and XLSX files together in an app you can explore on your own terms.`)
};

const zh_gc_home_intro = /** @type {(inputs: Gc_Home_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源电子表格，熟悉的思考方式。GridCraft 将单元格、公式和 XLSX 文件带到一起，让你按照自己的节奏探索。`)
};

/**
* | output |
* | --- |
* | "An open-source spreadsheet, a familiar way of thinking. GridCraft brings cells, formulas and XLSX files together in an app you can explore on your own terms." |
*
* @param {Gc_Home_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_intro = /** @type {((inputs?: Gc_Home_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_intro(inputs)
	return zh_gc_home_intro(inputs)
});
export { gc_home_intro as "gc.home.intro" }